import type { LocaleCodes, Locales } from '@flywire/internal-components/utils/translations/types';

// DO NOT REMOVE THE .ts extensions. DENO uses it for translations scripts
import { arSA } from './locales/ar-SA.ts';
import { deDE } from './locales/de-DE.ts';
import { enUS } from './locales/en-US.ts';
import { en } from './locales/en.ts';
import { es419 } from './locales/es-419.ts';
import { esES } from './locales/es-ES.ts';
import { frFR } from './locales/fr-FR.ts';
import { idID } from './locales/id-ID.ts';
import { itIT } from './locales/it-IT.ts';
import { jaJP } from './locales/ja-JP.ts';
import { koKR } from './locales/ko-KR.ts';
import { msMY } from './locales/ms-MY.ts';
import { ptBR } from './locales/pt-BR.ts';
import { ptPT } from './locales/pt-PT.ts';
import { thTH } from './locales/th-TH.ts';
import { trTR } from './locales/tr-TR.ts';
import { viVN } from './locales/vi-VN.ts';
import { zhCN } from './locales/zh-CN.ts';

export const rtlLocales = [];
export const localeCodes = [
  'en',
  'en-US',
  'zh-CN',
  'es-ES',
  'ko',
  'ko-KR',
  'ja',
  'ja-JP',
  'fr-FR',
  'pt-PT',
  'de-DE',
  'id',
  'id-ID',
  'vi',
  'vi-VN',
  'ar',
  'ar-SA',
  'it-IT',
  'tr-TR',
  'th-TH',
  'es-419',
  'pt-BR',
  'ms-MY'
] as const;
export const locales: Locales = {
  en: en,
  'de-DE': deDE,
  'en-US': enUS,
  'zh-CN': zhCN,
  'es-ES': esES,
  ko: koKR,
  'ko-KR': koKR,
  ja: jaJP,
  'ja-JP': jaJP,
  'fr-FR': frFR,
  'pt-PT': ptPT,
  id: idID,
  'id-ID': idID,
  vi: viVN,
  'vi-VN': viVN,
  ar: arSA,
  'ar-SA': arSA,
  'it-IT': itIT,
  'tr-TR': trTR,
  'th-TH': thTH,
  'es-419': es419,
  'pt-BR': ptBR,
  'ms-MY': msMY
};

export const DEFAULT_LOCALE: LocaleCodes = 'en';
